import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import esriLogger from '@arcgis/core/core/Logger';
import { logSessionHeader } from '@origo/logger';
import { getCustomerDomain } from '@origo/auth';
import './index.css';
import '../../packages/origo-ui/index.css';
import '../../packages/origo-ui/dist/style.css';
// Georg: bare komponent-CSS-en (CSS-moduler) foreløpig. Tokens og grunnstiler
// kommer fortsatt fra origo-ui/index.css til appen er portet.
import '@geodata/georg/style.css';
import '../../packages/origo-components/dist/style.css';

// Demp ArcGIS-deprecations i prod. Behold warnings i dev så vi fanger dem opp.
esriLogger.getLogger('esri').level = import.meta.env.PROD ? 'error' : 'warn';

logSessionHeader({
    app: 'synkadmin',
    version: __APP_VERSION__,
    commit: __APP_COMMIT__,
    customer: getCustomerDomain(),
    buildDate: __APP_BUILD_DATE__,
});

// Calcite-web-komponenter brukt av @origo/map-context sin Map-komponent.
import '@esri/calcite-components/dist/components/calcite-switch';
import '@esri/calcite-components/dist/components/calcite-panel';
import '@esri/calcite-components/dist/components/calcite-block';
import '@esri/calcite-components/dist/components/calcite-button';
import '@esri/calcite-components/dist/components/calcite-label';
import '@esri/calcite-components/dist/components/calcite-icon';
import '@esri/calcite-components/dist/components/calcite-tooltip';
import '@esri/calcite-components/dist/components/calcite-action';
import '@esri/calcite-components/dist/components/calcite-action-bar';
import '@esri/calcite-components/dist/components/calcite-action-group';
import '@esri/calcite-components/dist/components/calcite-loader';
import '@esri/calcite-components/dist/components/calcite-scrim';
import '@esri/calcite-components/dist/components/calcite-segmented-control';
import '@esri/calcite-components/dist/components/calcite-segmented-control-item';

// Initialiser i18n med sammenslåtte ressurser fra pakker og app.
import { createI18n } from '@origo/i18n';
import { uiTranslations } from '@origo/origo-components';
import { mapTranslation } from '@origo/map-context';
import appNb from './translations/nb.json';
import appEn from './translations/en.json';

export const i18n = createI18n({
    defaultLanguage: 'nb',
    resources: [
        uiTranslations,
        mapTranslation,
        { nb: { translation: appNb }, en: { translation: appEn } },
    ],
});

import '@arcgis/core/assets/esri/themes/light/main.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);
